import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-common-counter',
  standalone: false,
  templateUrl: './common-counter.component.html',
  styleUrl: './common-counter.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommonCounterComponent),
      multi: true
    }
  ]
})
export class CommonCounterComponent implements ControlValueAccessor {

  @Input() MIN: number = 0
  @Input() MAX: number = 100;
  value: number = 1;

  incrementQuantity(): void {
    if (this.value>=this.MAX){
      this.value=this.MAX;
    }
    else{
      this.value = Number(this.value) + 1;
    }
    this.updateControl(this.value)
  }

  // Decrement the quantity, but not below 0
  decrementQuantity(): void {
    if (this.value > this.MIN) {
      this.value -= 1;
    }
    this.updateControl(this.value)
  }

  validateQuantity(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;

    // Check if the input is a valid number
    if (!/^\d*$/.test(inputValue)) {
      this.value = this.MIN; // Reset to min if invalid
    } else {
      let num = Number(inputValue);
      if (num < this.MIN) {
        num = this.MIN;
      } else if (num > this.MAX) {
        num = this.MAX;
      }
      this.value = num;
    }

    this.updateControl(this.value);
    // Also update the input field value to reflect the clamped value
    (event.target as HTMLInputElement).value = String(this.value);
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  updateControl(value: number) {
    this.onChange(value);
    this.onTouched();
  }
}
